import React from 'react'

export default function CareerGuidance() {
  return (
    <section dir="rtl" className="bg-slate-50 min-h-screen py-16 px-4">
      <div className="max-w-3xl mx-auto bg-white rounded-3xl shadow-md border border-slate-200 p-8 space-y-6">
        <h1 className="text-3xl font-extrabold text-sky-700 text-center">
          جلسات الإرشاد المهني
        </h1>
        <ul className="flex flex-col md:flex-row gap-4">
          <li className="flex-1 bg-sky-50 border border-sky-200 rounded-xl p-4 shadow-sm text-center font-semibold">
            بناء وتقييم السيره الذاتيه
          </li>
          <li className="flex-1 bg-sky-50 border border-sky-200 rounded-xl p-4 shadow-sm text-center font-semibold">
            التخطيط والتطور المهني
          </li>
          <li className="flex-1 bg-sky-50 border border-sky-200 rounded-xl p-4 shadow-sm text-center font-semibold">
            المقابلات الشخصيه
          </li>
          <li className="flex-1 bg-sky-50 border border-sky-200 rounded-xl p-4 shadow-sm text-center font-semibold">
            تحليل الميول والاهتمامات المهنيه
          </li>
        </ul>

      </div>
    </section>

  )
}
